import { render, staticRenderFns } from "./BaseNotificationLocal.vue?vue&type=template&id=7c1c22ef&scoped=true&"
import script from "./BaseNotificationLocal.vue?vue&type=script&lang=js&"
export * from "./BaseNotificationLocal.vue?vue&type=script&lang=js&"
import style0 from "./BaseNotificationLocal.vue?vue&type=style&index=0&id=7c1c22ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1c22ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c1c22ef')) {
      api.createRecord('7c1c22ef', component.options)
    } else {
      api.reload('7c1c22ef', component.options)
    }
    module.hot.accept("./BaseNotificationLocal.vue?vue&type=template&id=7c1c22ef&scoped=true&", function () {
      api.rerender('7c1c22ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseNotificationLocal.vue"
export default component.exports